import React from 'react'
import { Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { FormFieldError, FormFieldLabel, FormTextArea, FormTextInput } from '../atoms/FormTextInput'
import SellContractSegmentField, {
  sellContractFieldClass,
  SellContractFormControls,
  ShowSellContractError
} from './SellContractSegmentField'
import { SellContractFormData } from 'src/helpers/sellContractFormValidation'

interface SellContractConditionSectionProps {
  values: SellContractFormData
  form: SellContractFormControls
  showError: ShowSellContractError
}

const SellContractConditionSection = ({ values, form, showError }: SellContractConditionSectionProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <div className="text-zinc-900 text-xl font-bold font-Montserrat leading-7">{t('sell_contract.remarks')}</div>
      <div className="self-stretch flex flex-col justify-start items-start gap-6">
        <SellContractSegmentField
          name="mileage_statement"
          label={t('sell_contract.mileage_statement')}
          values={values}
          form={form}
          showError={showError}
          className="w-full"
          fallback="known"
          options={[
            { value: 'known', label: t('sell_contract.mileage_statement_known') },
            { value: 'unknown', label: t('sell_contract.mileage_statement_unknown') },
            { value: 'custom', label: t('sell_contract.mileage_statement_custom') }
          ]}
        />
        {values.mileage_statement === 'custom' && (
          <Field name="mileage_statement_text">
            {({ input, meta }) => (
              <div className={sellContractFieldClass}>
                <FormFieldLabel label={t('sell_contract.mileage_statement_text')} />
                <FormTextArea
                  value={input.value ?? ''}
                  onChange={input.onChange}
                  placeholder={t('sell_contract.mileage_statement_text')}
                  error={showError(meta)}
                />
                <FormFieldError show={showError(meta)} message={t('sell_contract.field_required')} />
              </div>
            )}
          </Field>
        )}
        <Field name="previous_owners_basis">
          {({ input }) => (
            <div className={sellContractFieldClass}>
              <FormFieldLabel label={t('sell_contract.previous_owners_basis')} />
              <FormTextArea
                value={input.value ?? ''}
                onChange={input.onChange}
                placeholder={t('sell_contract.previous_owners_basis_placeholder')}
              />
            </div>
          )}
        </Field>
        <Field name="key_count">
          {({ input }) => (
            <div className={`w-[460px] ${sellContractFieldClass}`}>
              <FormFieldLabel label={t('sell_contract.key_count')} />
              <FormTextInput value={input.value ?? ''} onChange={input.onChange} placeholder="" />
            </div>
          )}
        </Field>
        <Field name="other_equipment">
          {({ input }) => (
            <div className={sellContractFieldClass}>
              <FormFieldLabel label={t('sell_contract.other_equipment')} />
              <FormTextArea value={input.value ?? ''} onChange={input.onChange} placeholder="" />
            </div>
          )}
        </Field>
        <Field name="missing_items">
          {({ input }) => (
            <div className={sellContractFieldClass}>
              <FormFieldLabel label={t('sell_contract.missing_items')} />
              <FormTextArea value={input.value ?? ''} onChange={input.onChange} placeholder="" />
            </div>
          )}
        </Field>
        <Field name="deviations_description">
          {({ input }) => (
            <div className={sellContractFieldClass}>
              <FormFieldLabel label={t('sell_contract.remarks')} />
              <FormTextArea
                value={input.value ?? ''}
                onChange={input.onChange}
                placeholder={t('sell_contract.remarks_hint')}
              />
            </div>
          )}
        </Field>
      </div>
    </>
  )
}

export default SellContractConditionSection
